(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('PurchasedProductDeleteController',PurchasedProductDeleteController);

    PurchasedProductDeleteController.$inject = ['$uibModalInstance', 'entity', 'PurchasedProduct'];

    function PurchasedProductDeleteController($uibModalInstance, entity, PurchasedProduct) {
        var vm = this;

        vm.purchasedProduct = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PurchasedProduct.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
